import { Link } from "react-router";
import { HeroCarousel } from "../components/HeroCarousel";
import { NewsletterPopup } from "../components/NewsletterPopup";
import { PerksStrip } from "../components/PerksStrip";
import { DEFAULT_FILTERS } from "../../shared/filters";
import { ProductGrid, ProductGridSkeleton } from "../components/ProductGrid";
import { ErrorMessage } from "../components/StatusMessage";
import { useI18n } from "../i18n/I18nProvider";
import { api } from "../lib/api";
import { ComingSoonHero } from "../components/ComingSoon";
import { useCatalog, useComingSoon, useStoreSales } from "../lib/CatalogProvider";
import { useAsync } from "../lib/useAsync";
import { useGame } from "../lib/GameProvider";
import { NewArrivals, SealedTabs, SetGrid } from "./home/HomeMarket";

export function HomePage() {
  const { t, pick } = useI18n();
  const { catalog } = useCatalog();
  const comingSoon = useComingSoon();
  // The store's perks and the newsletter's coupon are for its own sales.
  const storeSales = useStoreSales();
  const { game } = useGame();
  const featured = useAsync((signal) => api.products({ ...DEFAULT_FILTERS, games: [game], inStock: true, pageSize: 8 }, signal), [game]);

  return (
    <>
      {comingSoon ? <ComingSoonHero /> : <HeroCarousel />}
      {!comingSoon && storeSales && <PerksStrip />}
      {!comingSoon && storeSales && <NewsletterPopup />}

      <NewArrivals />
      <SetGrid />
      <SealedTabs />

      <section className="container section">
        <div className="section-head">
          <h2 className="section-title">{t("home.featured")}</h2>
          <Link to="/mercado">{t("home.viewAll")} →</Link>
        </div>
        {featured.error ? (
          <ErrorMessage onRetry={featured.reload} />
        ) : featured.loading || !featured.data ? (
          <ProductGridSkeleton count={8} />
        ) : (
          <ProductGrid products={featured.data.items} />
        )}
      </section>

      {!comingSoon && (
        <section className="container section">
          <div className="home-sell">
            <div>
              <h2>{t("sell.homeTitle")}</h2>
              <p>{t("sell.homeText")}</p>
            </div>
            <Link to="/vender" className="btn btn-accent btn-lg">
              {t("sell.homeCta")}
            </Link>
          </div>
        </section>
      )}

      {catalog.categories.length > 0 && (
        <section className="container section">
          <h2 className="section-title">{t("home.byCategory")}</h2>
          <div className="chip-row">
            {catalog.categories.map((c) => (
              <Link key={c.slug} to={`/mercado?categoria=${c.slug}`} className="chip">
                {pick(c.name)}
              </Link>
            ))}
          </div>
        </section>
      )}
    </>
  );
}
